module.exports = __webpack_public_path__ + "static/media/Wed.8e940216.jpg";